module.exports = __webpack_public_path__ + "img/no-active.fffd84b5.png";